<template>
    <div class="svg-container ">
        <svg id="ie-number-line-chart"></svg>
    </div>
</template>

<script>
    // import { gsap } from '/src/assets/js/gsap';
    import * as d3 from "d3";
    
    export default {
        name: 'balancenumberline',
        props : { chartData:Array },
        data () {
            return {}
        },
        mounted () {
            this.dataCheck(this.chartData);
        },
        methods: {
            dataCheck (arr) {
                if(Array.isArray(arr)) {
                    this.makeNumberLine();
                }
            },
            makeNumberLine () {

                console.table(this.chartData)

                // const height = 800;
                // const width = 900;
                // const chartWidth = 700;
                // const chartHeight = 500;
                // const margin = 100;
                // const offset = 100;

                // // append the svg object to the div called 'my_dataviz'
                // const svg = d3.select("#ie-number-line-chart")
                //     .attr("width", chartWidth)
                //     .attr("height", chartHeight)
                //     .attr("viewBox", `0 0 ${chartWidth} ${chartHeight}`)
                //     .attr("preserveAspectRatio", "xMidYMid meet")
                //     .append("g")
                //         .attr("transform", `translate(${0}, ${0})`); // places pie in the center

                // // X axis line setup
                // var x = d3
                //     .scaleLinear()
                //     .domain([-10, 10])
                //     .range([ 200, chartWidth- 200]);

                // svg.append("g") // chart transform and wrap
                //     .attr("class", "chart-style numberLine")
                //     .call(d3.axisBottom(x))
                //     .attr("transform", `translate(${0}, ${chartHeight - offset})`)

                // // draw center line
                // const chartData = this.chartData

                // svg.selectAll("bars")
                //     .data(this.chartData)
                //     .enter()
                    
                //     .append("rect")
                //     .attr("x", function(d) { return (d.start) })
                //     .attr("y", function(d, i) { return (i * 100) })
                //     .attr("width", function(d) { return (Math.abs(d.start) + Math.abs(d.end)) })
                //     .attr("height", 50 )
                //     .attr("fill", "#69b3a2")
                
                // const height = 400;
                // const width = 900;
                const chartWidth = 500;
                const chartHeight = 300;
		
                // var data = [
                //     {value: -10, dataset:"barbaz"},
                //     {value: 40, dataset:"barbar"},
                //     {value: -10, dataset:"foobaz"},
                //     {value: -50, dataset:"foobar"}
                // ];
                var data = this.chartData

                // Add svg to
                var svg = d3.select("#ie-number-line-chart")
                    // .append('svg')
                    .attr('width', chartWidth)
                    .attr('height', chartHeight)
                    .attr("viewBox", `0 0 ${chartWidth} ${chartHeight}`)
                    .attr("preserveAspectRatio", "xMidYMid meet")
                    .append('g')
                    .attr('transform', 'translate(' + 50 + ', 0)')
                    .attr('class', 'container')

                // set the ranges
                var y = d3.scaleBand()
                    .range([chartHeight-20, 0])
                    .padding(0.5);

                var x = d3.scaleLinear()
                    .range([0, chartWidth - 100]);

                // Scale the range of the data in the domains
                x.domain([-10,10])
                // x.domain(d3.extent(data, function (d) {
                //     return d.value;
                // }));
                y.domain(data.map(function (d) {
                    return d.dataset;
                }));
                

                // append the rectangles for the bar chart
                svg.selectAll(".bar")
                    .data(data)
                    .enter()
                    .append("rect")
                    // .attr("class", function (d) {
                    //     return "bar bar--" + (d.value < 0 ? "negative" : "positive");
                    // })
                    .attr("x", function (d) {
                        return x(Math.min(0, d.value));
                    })
                    .attr("y", function (d) {
                        return y(d.dataset);
                    })
                    .attr("width", function (d) {
                        return Math.abs(x(d.value) - x(0));
                    })
                    .attr("height", y.bandwidth())
                    .attr("fill", "#2caddc")
                    .attr("stroke", "#1e7ea1")
                    .attr("stroke-width", "2px")
                
                svg.append('line')
                    .style("stroke", "red")
                    .style("stroke-width", 5)
                    .attr("x1", (chartWidth-100)/2)
                    .attr("y1", 10)
                    .attr("x2", (chartWidth-100)/2)
                    .attr("y2", chartHeight-20);

                svg
                    .append("g")
                    .attr("class", "numberLine")
                    .attr('transform', `translate(0,${18})`)
                    .selectAll("bars-labels")
                    .data(data)
                    .enter()
                    .append("text")
                        .text(function(d) {                 
                            return d.label;
                        })
                        // .attr("class", "chart-style bar-text")
                        // .attr("x", function(d) { return x(d.label) + offset + x.bandwidth()/4; })
                        // .attr("y", function(d) { return y(d.baseline) + offset - 10; })
                        .attr("x", function (d) {
                            if(d.placement === "l") { return 0}
                            else {return 400}
                            
                            // return x(Math.min(0, d.value));
                        })
                        .attr("y", function (d) {
                            return y(d.dataset);
                        })
                        .attr("text-anchor", "middle")
                        .attr("font-size", "12px")   
                        .attr("fill", "#000000")            

                

                // add the x Axis
                svg.append("g")
                    .attr("transform", `translate(0,${chartHeight -20})`)
                    .call(d3.axisBottom(x));
                
                // add the y Axis
                // let yAxisGroup = svg.append("g")
                //     .attr("class", "y axis")
                //     .attr("transform", "translate(" + x(0) + ",0)")
                //     .call(d3.axisRight(y));
                // yAxisGroup.selectAll('.tick')
                //     .data(data)
                //     .select('text')
                //     .attr('x', function(d,i){return d.value<0?9:-9})
                //     .style('text-anchor', function(d,i){return d.value<0?'start':'end'})
                
                
            },
            getPlacement(p) {
                if (p === "l") {
                    return 0
                } else return 400
            },
            wrap (text, width) {
                text.each(function() {
                    var text = d3.select(this),
                        words = text.text().split(/\s+/).reverse(),
                        word,
                        line = [],
                        lineNumber = 0,
                        lineHeight = 1.1, // ems
                        y = text.attr("y"),
                        dy = parseFloat(text.attr("dy")),
                        tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
                    while (word = words.pop()) {
                    line.push(word);
                    tspan.text(line.join(" "));
                    if (tspan.node().getComputedTextLength() > width) {
                        line.pop();
                        tspan.text(line.join(" "));
                        line = [word];
                        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
                    }
                    }
                });
            }
        }  
    }
</script>
